import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import { ContentBox } from '@src/elements/content-box/content-box'
import { Divider } from '@src/elements/divider/divider'
import { Icon } from '@src/elements/icon/icon'
import { Breadcrumbs } from '@src/elements/breadcrumbs/breadcrumbs'
import { ActionBar } from '@src/components/action-bar/action-bar'

import { track } from '@src/util/functions'

import './create-member.sass'

@Component
export class CreateMember extends Vue {

  constructor () {
    super()
    track('/members/new')
  }

  createNewMember () {
    this.$router.push('/trainers/platform/members/create')
  }

  connectMobileMember () {
    this.$router.push('/trainers/platform/members/connect-mobile')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.LIST.CREATE_MEMBER')}`
  }

  goToUsers () {
    this.$router.push('/trainers/platform/members')
  }

  renderActionBar (h: CreateElement) {
    return <ActionBar>
      <Breadcrumbs clickAction={this.goToUsers} crumbs={[
        <div ref='goto-users'>{this.$t('USERS')}</div>
      ]} />
      <Subtitle2>{this.$t('PAGE.MEMBERS.LIST.CREATE_MEMBER')}</Subtitle2>
    </ActionBar>
  }

  render (h: CreateElement) {
    return <div class='create-member-wrapper'>
      {this.renderActionBar(h)}
      <ContentBox>
        <div class='add-options' slot='content'>
          <Icon class='create-user-icon' name={'util/add-user'} />
          <Subtitle1>{this.$t('PAGE.MEMBERS.ACCOUNT.CREATE_MEMBER_OPTION')}</Subtitle1>
          <Button ref='create-account' type='elevated' label={this.$t('CREATE')} click={this.createNewMember} />
          <Divider />
          <Icon name={'util/import-mobile'} />
          <Subtitle1>{this.$t('PAGE.MEMBERS.ACCOUNT.CONNECT_MEMBER_MOBILE_OPTION')}</Subtitle1>
          <Button ref='connect-mobile-account' type='elevated' label={this.$t('ADD')} click={this.connectMobileMember} />
        </div>
      </ContentBox>
    </div>
  }
}
